function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';
const Processing = props => /*#__PURE__*/React.createElement(Svg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 221,
  height: 126,
  fill: "none"
}, props), /*#__PURE__*/React.createElement(G, {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#545F71",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M29.083 89.208h44.933m-44.933 25.387h44.933m-44.933-12.687h44.933M3.679 124.849h185.359m-6.762-51.452v51.452m-46.535-52.103v52.103m-42.418-57.92h51.85M20.589 124.85V78.472h61.92v46.377m13.094-56.006v56.006M9.046 68.843v56.006m50.509-81.446h71.796l23.789 17.294m33.924 17.216-29.795-19.806-32.543 20.378m-23.685-4.36-50.69-35.953L.877 74.946m123.764 50.125V91.147h-17.718v33.924m62.168-23.332h-20.167V81.465h20.167v20.274Z"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#EBF1FF",
  stroke: "#111C2B",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M167.829 104.419c28.37 0 51.368-22.971 51.368-51.309 0-28.337-22.998-51.309-51.368-51.309s-51.369 22.972-51.369 51.31c0 28.337 22.999 51.308 51.369 51.308Z"
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M175.199 42.203c2.2-3.798 7.09-5.095 10.893-2.906a7.91 7.91 0 0 1 2.92 10.838c-2.2 3.797-7.09 5.095-10.907 2.892a7.911 7.911 0 0 1-2.92-10.838l.014.014Z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M185.128 60.257a14.561 14.561 0 0 1-6.017 0l-3.206 4.23-6.587-3.784 2.064-4.879a14.024 14.024 0 0 1-3.015-5.189l-5.27-.662v-7.595l5.283-.648c.299-.946.707-1.865 1.236-2.757a14.71 14.71 0 0 1 1.78-2.446l-2.078-4.865 6.587-3.81 3.219 4.23a14.337 14.337 0 0 1 6.017.013l3.206-4.23 6.587 3.784-2.064 4.878a14.024 14.024 0 0 1 3.015 5.19l5.27.661v7.595l-5.283.635a13.86 13.86 0 0 1-1.236 2.757 14.648 14.648 0 0 1-1.78 2.446l2.078 4.878-6.587 3.811-3.219-4.23v-.013ZM148.971 69.392a4.904 4.904 0 0 0 4.903-4.905 4.904 4.904 0 1 0-9.807 0 4.905 4.905 0 0 0 4.904 4.905Z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "M156.4 72.77a11.067 11.067 0 0 1-4.007 2.311l-.502 4.068h-5.841l-.502-4.068a10.693 10.693 0 0 1-4.007-2.31l-3.763 1.594-2.92-5.081 3.26-2.473a10.883 10.883 0 0 1-.244-2.325c0-.797.081-1.567.244-2.324l-3.26-2.46 2.92-5.08 3.763 1.594a11.067 11.067 0 0 1 4.007-2.31l.502-4.068h5.841l.502 4.067a10.693 10.693 0 0 1 4.007 2.311l3.763-1.594 2.92 5.08-3.26 2.46c.163.757.245 1.527.245 2.325 0 .797-.082 1.567-.245 2.324l3.26 2.473-2.92 5.08-3.763-1.594Z"
}))), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
  id: "a"
}, /*#__PURE__*/React.createElement(Path, {
  fill: "#fff",
  d: "M.5.5h220v125H.5z"
})), /*#__PURE__*/React.createElement(ClipPath, {
  id: "b"
}, /*#__PURE__*/React.createElement(Path, {
  fill: "#fff",
  d: "M133.5 26.5h69v54h-69z"
}))));
export default Processing;
//# sourceMappingURL=Processing.js.map